import _ from 'lodash';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { GET } from 'src/utils/services';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { SectionHead } from 'src/components/cards';
import { useMediaQuery } from 'react-responsive';
import dynamic from 'next/dynamic';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { SHOW_COMMEMORATE } from 'src/constants';
const Carousels = dynamic(import('src/components/carousels'));
const CardVHeight = dynamic(import('src/components/cards/card-v-height'));

const SectionFour = () => {
  const [sectionFour, setSectionFour] = useState(null);
  const isTabletOrMobile = useMediaQuery({ maxWidth: 690 });
  const isDesktop = useMediaQuery({ minWidth: 691 });
  const router = useRouter();

  useEffect(() => {
    (async () => {
      const payload = {
        block1: 4,
        block2: 0,
        block3: 0
      };
      const uri = `/api/v1.0/home/section-four${convertObjPath(payload)}`;
      try {
        const data = await GET(uri, false, true);
        if (!_.isEmpty(data)) setSectionFour(data);
      } catch (err) {
        console.error(`${timestamp()} ==========> SECTION FOUR ERROR : ${uri}`, err.message);
      }
    })();
  }, []);

  if (_.isEmpty(sectionFour)) return null;

  const { block1 } = sectionFour;

  return (
    <>
      <SectionWrapper id='section-7' className='section-bg' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset' }}>
        <div className='container'>
          {/* --------------------------------- BLOCK 1 -------------------------------- */}
          <div className='block-1-section-4'>
            {!_.isEmpty(block1?.data) && (
              <>
                <SectionHead data={block1?.title} link={block1?.link} />
                <div className='row card-list'>
                  {isDesktop && (
                    <>
                      {block1?.data?.map((item, index) => (
                        <div key={index} className='card-item col-12 col-md-3'>
                          <CardVHeight
                            data={item}
                            pinTag={true}
                            showBlurb={true}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_INDEX,
                              router: router?.pathname,
                              section: 'section-7',
                              data: {
                                title: item?.title,
                                heading: block1?.title,
                                index: index + 1
                              }
                            }}
                          />
                        </div>
                      ))}
                    </>
                  )}
                  {isTabletOrMobile && (
                    <Carousels dots={false} autoplaySpeed={6000}>
                      {block1?.data?.map((item, index) => (
                        <div key={index} className='card-item col-12 col-md-3'>
                          <CardVHeight
                            data={item}
                            pinTag={false}
                            showBlurb={false}
                            showCountview={false}
                            showTime={false}
                            showByline={false}
                            showTitle={false}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_INDEX,
                              router: router?.pathname,
                              section: 'section-7',
                              data: {
                                title: item?.title,
                                heading: block1?.title,
                                carousel: index + 1
                              }
                            }}
                          />
                        </div>
                      ))}
                    </Carousels>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </SectionWrapper>
    </>
  );
};

const SectionWrapper = styled.section`
  position: relative;
  display: block;
  /* .section-head {
    padding-bottom: 24px;
    @media (max-width: 690px) {
        padding-bottom: 15px;
      }
  } */
  .card-list {
    margin: 0 -15px;
    .card-item {
      padding: 0 15px;
      .card-content {
        margin-top: 10px;
      }
    }
  }

  @media (max-width: 690px) {
    .slick-slider {
      .next-arrow,
      .slick-next,
      .prev-arrow,
      .slick-prev {
        top: 50%;
        transform: translate(0, -50%);
      }
    }
  }
`;

export default SectionFour;
